// M46 — Version comparison utilities.
//
// Lives in `lib/` (not co-located with `StaleBundleBanner.tsx`) so the
// banner file only exports a component, satisfying the
// react-refresh/only-export-components rule.

/** True when `a` is strictly newer than `b` as a "MAJOR.MINOR.PATCH"
 *  semver. Missing components compare as 0 so "0.2" reads as newer
 *  than "0.1.99". Non-numeric components fall to 0 — we don't ship
 *  prerelease tags in the version string, so this is fine.
 *
 *  Why this exists: a plain string comparison gets "0.1.10" < "0.1.9"
 *  backwards. The DB-side `version_sort` generated column handles
 *  that for SQL queries; this is the client-side mirror used by the
 *  stale-bundle banner to compare the baked-in `__APP_VERSION__`
 *  against the latest published changelog row. */
export function isVersionNewer(a: string, b: string): boolean {
  const pa = a.split('.').map((n) => Number(n) || 0);
  const pb = b.split('.').map((n) => Number(n) || 0);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const da = pa[i] ?? 0;
    const db = pb[i] ?? 0;
    if (da !== db) return da > db;
  }
  return false;
}
